import {useMemo} from 'react'
import * as PropTypes from 'prop-types'
import {CSSTransition} from 'react-transition-group'
import {useTranslation} from 'react-i18next'
import {useLocation} from 'react-router-dom'
import {useQueryParam} from 'use-query-params'

import {elementIds} from 'constData'
import {useLogout, useProfile} from 'hooks'
import {ReactComponent as LogoutIcon} from 'images/icons/profile/logout-icon.svg'
import {translatedUrl} from 'i18n/utils'
import {isProfileConfirmed} from 'utils'

import {hideNavItems, mobileNavItems} from '../Navigation.config'
import {DepositBtnWrapper} from '../TopNavigation/TopNavigation.styles'
import ProfileNavItem from '../ProfileNavItem'

import {
  LogoutButton,
  MobileNavigationLinks,
  MobileNavigationWrapper,
  MobNaVDarkBg,
  MobNavLink,
} from './MobileNavigation.styles'

const MobNav = ({opened, onClose}) => {
  const {t} = useTranslation()
  const logout = useLogout()
  const {profile} = useProfile()
  const isConfirmed = isProfileConfirmed(profile)
  const [buyToken] = useQueryParam('type')
  const location = useLocation()

  const buyTokenRoute = useMemo(() => buyToken && buyToken === 'purchaseToken', [buyToken])
  const itemFilter = useMemo(
    () =>
      mobileNavItems.map(item =>
        item.title.toLowerCase() === 'buy'
          ? {...item, isActive: buyTokenRoute}
          : {
              ...item,
              isActive: location.pathname.includes('wallet')
                ? item.link === '/wallet' && !buyTokenRoute
                  ? true
                  : false
                : location.pathname.includes('profile')
                  ? item.link === '/profile'
                    ? true
                    : false
                  : location.pathname === item.link,
            },
      ),
    // eslint-disable-next-line
    [location],
  )

  return (
    <>
      <CSSTransition in={opened} classNames='slide' timeout={300} unmountOnExit>
        <MobileNavigationWrapper>
          <div>
            <ProfileNavItem id={elementIds.navigation.items.profile} onClick={onClose} />
            {!hideNavItems && (
              <DepositBtnWrapper>
                {isConfirmed
                  ? /*<Button
                    size='def'
                    minWidth='135px'
                    to={routes.wallet.path}
                    onClick={onClose}
                    text={t('navigation.depositBtn')}
                  />*/
                    ''
                  : ''}
              </DepositBtnWrapper>
            )}
            <MobileNavigationLinks>
              {itemFilter.map(({id, title, Icon, link, isActive}) => (
                <MobNavLink
                  id={id}
                  key={link}
                  to={translatedUrl(link)}
                  onClick={onClose}
                  $isActive={isActive}
                >
                  <Icon />
                  {title}
                </MobNavLink>
              ))}
            </MobileNavigationLinks>
          </div>
          <LogoutButton id={elementIds.navigation.items.logout} as='button' onClick={logout.mutate}>
            <LogoutIcon />
            {t('navigation.logout')}
          </LogoutButton>
        </MobileNavigationWrapper>
      </CSSTransition>

      <CSSTransition in={opened} classNames='fade' timeout={300} unmountOnExit>
        <MobNaVDarkBg onClick={onClose} />
      </CSSTransition>
    </>
  )
}

MobNav.propTypes = {
  opened: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}
MobNav.defaultProps = {}

export default MobNav
